import { StytchClient } from './StytchClient.mjs';
import { ssrSafeClientFactory } from './ui/react/bindings/StytchSSRProxy.mjs';

/**
 * Creates a Headless Stytch client object to call the stytch APIs.
 * The Stytch client is not available serverside.
 * @example
 * const stytch = createStytchClient('public-token-<find yours in the stytch dashboard>')
 *
 * return (
 *   <StytchProvider stytch={stytch}>
 *     <App />
 *   </StytchProvider>
 * )
 * @returns A {@link StytchClient}
 */ const createStytchClient = ssrSafeClientFactory(StytchClient);
/**
 * @deprecated Use createStytchClient instead
 */ const createStytchHeadlessClient = createStytchClient;
/**
 * @deprecated Use StytchClient instead
 */ const StytchHeadlessClient = StytchClient;

export { StytchClient, StytchHeadlessClient, createStytchClient, createStytchHeadlessClient };
//# sourceMappingURL=index.headless.mjs.map
